export default function FolderUploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="73"
      viewBox="0 0 72 73"
      fill="none"
    >
      <g clipPath="url(#clip0_1564_28730)">
        <path
          d="M36 57.2969H15C13.4087 57.2969 11.8826 56.6647 10.7574 55.5395C9.63214 54.4143 9 52.8882 9 51.2969V18.2969C9 16.7056 9.63214 15.1795 10.7574 14.0542C11.8826 12.929 13.4087 12.2969 15 12.2969H25.7574C26.553 12.2969 27.3161 12.6129 27.8787 13.1756L36 21.2969H57C58.5913 21.2969 60.1174 21.929 61.2426 23.0542C62.3679 24.1795 63 25.7056 63 27.2969V37.7969"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M57 66.2969V48.2969"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66 57.2969L57 48.2969L48 57.2969"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1564_28730">
          <rect
            width="72"
            height="72"
            fill="none"
            transform="translate(0 0.296875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
